// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"HoverCard_cardContainer__rGv2e","cardContentBox":"HoverCard_cardContentBox__m44zV","cardtitle":"HoverCard_cardtitle__Tt6bT","cardDesc":"HoverCard_cardDesc___0WAq"};